import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

const UsersPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Kullanıcılar" />
      <div className="card">
        <div className="card-body">
          <h5>Kullanıcılar</h5>
          <p>Bu sayfa yakında eklenecek.</p>
        </div>
      </div>
    </MasterLayout>
  );
};

export default UsersPage;

